import { render, staticRenderFns } from "./Segment.vue?vue&type=template&id=a463f76c&scoped=true"
import script from "./Segment.vue?vue&type=script&lang=js"
export * from "./Segment.vue?vue&type=script&lang=js"
import style0 from "./Segment.vue?vue&type=style&index=0&id=a463f76c&prod&lang=scss&scoped=true"
import style1 from "./Segment.vue?vue&type=style&index=1&id=a463f76c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a463f76c",
  null
  
)

export default component.exports